export default __webpack_public_path__ + "static/media/google-meet-conference.e0271c01.png";